import {Stack} from "@fluentui/react";
import * as React from "react";

function ActionField(props) {
    return (<Stack horizontal>
        <Stack.Item grow={3} style={{width: 'calc(100% - 32px)'}}>{props.field}</Stack.Item>
        <Stack.Item >{props.action}</Stack.Item>
    </Stack>);
}

export default ActionField;